module.exports = __webpack_public_path__ + "img/smicon.16af3c64.svg";